<template>
	<div class="add-iCard">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="iCard.id ? $t('addICard.edit') : $t('addICard.add')"
			:visible.sync="dialogICard"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div
				class="content"
				v-loading="loadingForm"
				:element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="iCard"
					label-width="80px"
					:model="iCard">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('addICard.cardNo')" prop="cardNo">
								<el-input
									v-model="iCard.cardNo"
									:placeholder="$t('addICard.pCardNo')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item :label="$t('addICard.cardName')" prop="cardName">
								<el-input
									v-model="iCard.cardName"
									:placeholder="$t('addICard.pCardName')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item
								:label="$t('addICard.availableNum')"
								prop="availableNum">
								<el-input
									v-model="iCard.availableNum"
									:placeholder="$t('addICard.pAvailableNum')"
									autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="12">
                            <el-form-item :label="$t('addICard.userName')" prop="uId">
                                <el-select v-model="iCard.uId"
                                           :no-data-text="$t('common.noData')" :no-match-text="$t('common.noData')"
                                           filterable
                                           :remote="uid && uid === '1'"
                                           clearable
                                           :remote-method="remoteMethod"
                                           :loading="loadingUser"
                                           :placeholder="$t('addICard.pUsername')">
                                    <el-option
                                            v-for="item in userList"
                                            :key="item.id"
                                            :label="item.userName"
                                            :value="item.id">
                                        <span style="float: left">{{ item.userName }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nickName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
						<el-col :span="12">
							<el-form-item
								:label="$t('addICard.receiveType')"
								prop="receiveType">
								<el-select
									v-model="iCard.receiveType"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									filterable
									:placeholder="$t('addICard.pReceiveType')">
									<el-option
										v-for="item in receiveTypeList"
										:key="item.id"
										:label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item :label="$t('addICard.level')" prop="level">
								<el-select
									v-model="iCard.level"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									filterable
									:placeholder="$t('addICard.pLevel')">
									<el-option
										v-for="item in levelList"
										:key="item.id"
										:label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								:label="$t('addICard.startEndTime')"
								prop="startTime">
								<el-date-picker
									style="width: 100%"
									@change="dateChanges"
									type="datetimerange"
									v-model="defaultvalue"
									:range-separator="$t('addICard.zhi')"
									:start-placeholder="$t('addICard.startDate')"
									:end-placeholder="$t('addICard.endDate')">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item :label="$t('addICard.notes')">
								<el-input
									type="textarea"
									:rows="4"
									v-model="iCard.notes"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="submitForm('iCard')">{{
					$t("common.definite")
				}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddICard",
	props: {
		dialogICard: Boolean,
		iCard: Object,
		labelPosition: {
			type: String,
			default: "top",
		},
		levelList: [],
		userList: [],
		receiveTypeList: [],
		defaultdate: [],
	},
	watch: {
		defaultdate(news) {
			this.defaultvalue = news;
		},
	},
	data() {
		return {
			rules: {
				cardNo: [
					{
						required: true,
						message: this.$t("addICard.pCardNo"),
						trigger: "blur",
					},
				],
				cardName: [
					{
						required: true,
						message: this.$t("addICard.pCardName"),
						trigger: "blur",
					},
				],
				startTime: [
					{
						required: true,
						message: this.$t("addICard.pStartEndTime"),
						trigger: "blur",
					},
				],
				level: [
					{
						required: true,
						message: this.$t("addICard.pLevel"),
						trigger: "blur",
					},
				],
				availableNum: [
					{
						required: true,
						message: this.$t("addICard.pLast"),
						trigger: "blur",
					},
					{
						pattern: /^[1-9]\d{0,1}$/,
						message: this.$t("addICard.pNum"),
						trigger: "blur",
					},
				],
				uId: [
					{
						required: true,
						message: this.$t("addICard.pUsername"),
						trigger: "blur",
					},
				],
				receiveType: [
					{
						required: true,
						message: this.$t("addICard.pReceiveType"),
						trigger: "blur",
					},
				],
			},
			loadingForm: false,
			clear: false,
			loadingUser: false,
			uid: this.$cookies.get("uid"),
			defaultvalue: this.iCard.startEndTimes,
		};
	},
	methods: {
		dateChanges(e) {
			if (!e) {
				this.iCard.startTime = "";
				this.iCard.endDate = "";
				return false;
			}
			let startTime = e[0];
			let startYear = new Date(startTime).getFullYear();
			let startMonth = new Date(startTime).getMonth();
			startMonth = startMonth + 1;
			if (parseInt(startMonth) < 10) {
				startMonth = "0" + startMonth;
			}
			let startDate = new Date(startTime).getDate();
			if (parseInt(startDate) < 10) {
				startDate = "0" + startDate;
			}
			let startHours = new Date(startTime).getHours();
			if (parseInt(startHours) < 10) {
				startHours = "0" + startHours;
			}
			let startMinutes = new Date(startTime).getMinutes();
			if (parseInt(startMinutes) < 10) {
				startMinutes = "0" + startMinutes;
			}
			let startSeconds = new Date(startTime).getSeconds();
			if (parseInt(startSeconds) < 10) {
				startSeconds = "0" + startSeconds;
			}
			startTime =
				startYear +
				"-" +
				startMonth +
				"-" +
				startDate +
				" " +
				startHours +
				":" +
				startMinutes +
				":" +
				startSeconds;
			this.iCard.startTime = startTime;
			let endTime = e[1];
			let endYear = new Date(endTime).getFullYear();
			let endMonth = new Date(endTime).getMonth();
			endMonth = endMonth + 1;
			if (parseInt(endMonth) < 10) {
				endMonth = "0" + endMonth;
			}
			let endDate = new Date(endTime).getDate();
			if (parseInt(endDate) < 10) {
				endDate = "0" + endDate;
			}
			let endHours = new Date(endTime).getHours();
			if (parseInt(endHours) < 10) {
				endHours = "0" + endHours;
			}
			let endMinutes = new Date(endTime).getMinutes();
			if (parseInt(endMinutes) < 10) {
				endMinutes = "0" + endMinutes;
			}
			let endSeconds = new Date(endTime).getSeconds();
			if (parseInt(endSeconds) < 10) {
				endSeconds = "0" + endSeconds;
			}
			endTime =
				endYear +
				"-" +
				endMonth +
				"-" +
				endDate +
				" " +
				endHours +
				":" +
				endMinutes +
				":" +
				endSeconds;
			this.iCard.endDate = endTime;
		},
		closeDialog() {
			if (this.iCard.id) {
				this.$toolUtil.clearForm(this.iCard);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.iCard);
				}
			}
			this.clearValidate("iCard");
			this.cancel("");
		},
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		openDialog() {
			if (this.uid === "1" && this.iCard.id) {
				this.loadingForm = true;
				this.$api
					.request(this.$url.User.getUserById, this.$method.get, {
						uId: this.iCard.uId,
					})
					.then(res => {
						if (res.code === 0 && res.data) {
							this.userList = [];
							this.userList.push(res.data);
						}
						this.loadingForm = false;
					})
					.catch(() => {
						this.loadingForm = false;
					});
			}
		},
		cancel(state) {
			this.$emit("cancel", false, state);
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.ICard.insert;
					let method = this.$method.post;
					if (this.iCard.id) {
						url = this.$url.ICard.update;
						method = this.$method.put;
					}
					delete this.iCard.startEndTime;
					this.$api
						.request(url, method, this.iCard)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.clear = true;
								this.cancel(this.iCard.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.loadingForm = false;
						});
				}
			});
		},
		remoteMethod(val) {
			if (val !== "") {
				this.$api
					.request(this.$url.User.listUserByUsername, this.$method.get, {
						userName: val,
					})
					.then(res => {
						if (res.code === 0) {
							this.userList = res.data;
						}
					});
			}
		},
	},
};
</script>

<style lang="scss"></style>
